import { Flex } from '@osmosis/tailwind-ui/components/Box';
import React, { PropsWithChildren } from 'react';

type Props = {
  text?: string;
  children?: React.ReactNode;
  onClose?: () => void;
  centreButtons?: boolean;
};

/**
 * Sticky footer for the modal component.
 */
const ModalFooter = (props: PropsWithChildren<Props>) => {
  const { children, centreButtons = true } = props;

  return (
    <Flex
      className={`bg-white justify-center items-center p-4 sticky border-t border-t-gray-100 bottom-0`}
    >
      <Flex
        className={`items-center w-full ${
          centreButtons ? 'justify-evenly' : 'justify-end'
        }`}
      >
        {children}
      </Flex>
    </Flex>
  );
};

export default ModalFooter;
